<template>
    <el-container>
        <el-main>
          <!-- 添加按钮和类型Tab -->
          <div class="header-actions">
            <el-button @click="showAddDialog" type="primary" class="mb20" size="small">+ 添加推荐关键字</el-button>
            <el-tabs v-model="searchForm.type" @tab-click="handleTypeTabClick" class="type-tabs">
              <el-tab-pane label="全部" name=""></el-tab-pane>
              <el-tab-pane label="商品" name="1"></el-tab-pane>
              <el-tab-pane label="物性表" name="2"></el-tab-pane>
              <el-tab-pane label="视频" name="3"></el-tab-pane>
              <el-tab-pane label="塑舰店" name="4"></el-tab-pane>
              <el-tab-pane label="其他" name="5"></el-tab-pane>
            </el-tabs>
          </div>
          
          <!-- 搜索表单 -->
          <el-form class="el-form-search" label-width="100px">
            <el-form-item label="关键字：">
              <el-input size="small" placeholder="请输入关键字" v-model="searchForm.keyword"></el-input>
            </el-form-item>
            <el-form-item label="显示状态：">
              <el-select v-model="searchForm.is_show" size="small" placeholder="请选择显示状态" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="显示" :value="1"></el-option>
                <el-option label="隐藏" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" " label-width="25px">
              <el-button size="small" type="primary" @click="search">搜索</el-button>
              <el-button size="small" type="text" @click="clearSearch">清空搜索条件</el-button>
            </el-form-item>
          </el-form>

          <!-- 数据表格 -->
          <el-table :data="list" :header-cell-style="{ 'background-color': '#F8F9FA' }">
            <template slot="empty">暂无数据</template>
            <el-table-column prop="keyword" label="关键字" align="center" min-width="150"></el-table-column>
            <el-table-column prop="type" label="类型" align="center" width="100">
              <template slot-scope="scope">
                {{ getTypeName(scope.row.type) }}
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" align="center" width="80"></el-table-column>
            <el-table-column prop="is_show" label="显示状态" align="center" width="100">
              <template slot-scope="scope">
                <span :style="{'color': scope.row.is_show ? '#409EFF' : '#F56C6C'}">
                  {{ scope.row.is_show ? '显示' : '隐藏' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="160" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="editKeyword(scope.row)">编辑</el-button>
                <el-button type="text" size="small" @click="deleteKeyword(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <Paging :total="total" :page="searchForm.page" :pageNum="searchForm.rows" @updatePageNum="updateData"></Paging>

          <!-- 添加/编辑对话框 -->
          <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @close="closeDialog">
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
              <el-form-item label="关键字" prop="keyword">
                <el-input v-model="form.keyword" placeholder="请输入关键字"></el-input>
              </el-form-item>
              <el-form-item label="类型" prop="type">
                <el-select v-model="form.type" placeholder="请选择类型" style="width: 100%">
                  <el-option label="商品" :value="1"></el-option>
                  <el-option label="物性表" :value="2"></el-option>
                  <el-option label="视频" :value="3"></el-option>
                  <el-option label="塑舰店" :value="4"></el-option>
                  <el-option label="其他" :value="5"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="排序" prop="sort">
                <el-input-number v-model="form.sort" :min="0" :max="9999" placeholder="请输入排序值"></el-input-number>
              </el-form-item>
              <el-form-item label="显示状态" prop="is_show" v-if="isEdit">
                <el-radio-group v-model="form.is_show">
                  <el-radio :label="1">显示</el-radio>
                  <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取消</el-button>
              <el-button type="primary" @click="submitForm">确定</el-button>
            </div>
          </el-dialog>
        </el-main>
    </el-container>
  </template>
  
  <script>
  import Paging from '@/components/paging'

  export default {
    components: {
      Paging
    },
    data() {
      return {
        searchForm: {
          page: 1,
          rows: 10,
          keyword: '',
          is_show: '',
          type: ''
        },
        list: [],
        total: 0,
        dialogVisible: false,
        dialogTitle: '添加推荐关键字',
        isEdit: false,
        form: {
          id: '',
          keyword: '',
          type: 1,
          sort: 0,
          is_show: 1
        },
        rules: {
          keyword: [
            { required: true, message: '请输入关键字', trigger: 'blur' }
          ],
          type: [
            { required: true, message: '请选择类型', trigger: 'change' }
          ],
          sort: [
            { required: true, message: '请输入排序值', trigger: 'blur' }
          ]
        },
        typeOptions: [
          { value: 1, label: '商品' },
          { value: 2, label: '物性表' },
          { value: 3, label: '视频' },
          { value: 4, label: '塑舰店' },
          { value: 5, label: '其他' }
        ]
      }
    },
    created() {
      this.getList()
    },
    methods: {
      // 获取列表数据
      getList() {
        const params = {
          page: this.searchForm.page,
          rows: this.searchForm.rows
        }
        
        if (this.searchForm.keyword) {
          params.keyword = this.searchForm.keyword
        }
        if (this.searchForm.is_show !== '') {
          params.is_show = this.searchForm.is_show
        }
        if (this.searchForm.type) {
          params.type = this.searchForm.type
        }

        this.$axios.post(this.$api.gateway.keywordRecommend.list, params)
          .then(res => {
            if (res.code === 0) {
              this.list = res.result.list || []
              this.total = res.result.total_number || 0
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(err => {
            this.$message.error('获取数据失败')
          })
      },
      
      // 搜索
      search() {
        this.searchForm.page = 1
        this.getList()
      },
      
      // 清空搜索条件
      clearSearch() {
        this.searchForm = {
          page: 1,
          rows: 10,
          keyword: '',
          is_show: '',
          type: ''
        }
        this.getList()
      },

      // 处理类型Tab点击
      handleTypeTabClick() {
        this.searchForm.page = 1
        this.getList()
      },
      
      // 分页更新
      updateData(val, status) {
        if (status === 0) {
          this.searchForm.rows = val
        } else {
          this.searchForm.page = val
        }
        this.getList()
      },
      
      // 显示添加对话框
      showAddDialog() {
        this.dialogTitle = '添加推荐关键字'
        this.isEdit = false
        this.form = {
          id: '',
          keyword: '',
          type: this.searchForm.type ? parseInt(this.searchForm.type) : 1,
          sort: 0,
          is_show: 1
        }
        this.dialogVisible = true
      },
      
      // 编辑关键字
      editKeyword(row) {
        this.dialogTitle = '编辑推荐关键字'
        this.isEdit = true
        this.form = {
          id: row.id,
          keyword: row.keyword,
          type: row.type,
          sort: row.sort,
          is_show: row.is_show
        }
        this.dialogVisible = true
      },
      
      // 删除关键字
      deleteKeyword(row) {
        this.$confirm('此操作将永久删除该推荐关键字, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post(this.$api.gateway.keywordRecommend.del, { id: row.id })
            .then(res => {
              if (res.code === 0) {
                this.$message.success('删除成功')
                this.getList()
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch(err => {
              this.$message.error('删除失败')
            })
        }).catch(() => {
          // 取消删除
        })
      },
      
      // 提交表单
      submitForm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const url = this.isEdit ? this.$api.gateway.keywordRecommend.edit : this.$api.gateway.keywordRecommend.add
            const params = {
              keyword: this.form.keyword,
              type: this.form.type,
              sort: this.form.sort
            }
            
            if (this.isEdit) {
              params.id = this.form.id
              params.is_show = this.form.is_show
            }
            
            this.$axios.post(url, params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.isEdit ? '编辑成功' : '添加成功')
                  this.dialogVisible = false
                  this.getList()
                } else {
                  this.$message.error(res.msg)
                }
              })
              .catch(err => {
                this.$message.error(this.isEdit ? '编辑失败' : '添加失败')
              })
          }
        })
      },
      
      // 关闭对话框
      closeDialog() {
        this.$refs.form.resetFields()
      },
      
      // 获取类型名称
      getTypeName(type) {
        const typeMap = {
          1: '商品',
          2: '物性表',
          3: '视频',
          4: '塑舰店',
          5: '其他'
        }
        return typeMap[type] || '未知'
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .el-main {
    background: #fff;
    display: flex;
    flex-direction: column;
    
    .mb20 {
      margin-bottom: 20px;
    }
  }

  .header-actions {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    
    .el-button {
      margin-right: 20px;
      margin-bottom: 0;
    }
    
    .type-tabs {
      flex: 1;
      
      /deep/ .el-tabs__header {
        margin-bottom: 0;
      }
      
      /deep/ .el-tabs__nav-wrap::after {
        height: 1px;
      }
    }
  }

  .el-table {
    border-left: 1px solid #e8eef1;
    border-right: 1px solid #e8eef1;
    
    /deep/ .el-input__inner {
      border-color: #fff;
    }
    
    /deep/ .el-input__inner:focus {
      border-color: #409eff;
    }
  }
  </style>
  